<template>
    <div>
        <h2><strong style="color:#1A0054">Información general</strong></h2>
        <div id="dashboard-su" class="mb-5 bg-white rounded">
            <div class="row my-3 p-3 mx-0 rounded align-items-start">
                <div class="col-6 col-md-3 fs-5 py-1 px-lg-5 px-md-5 px-sm-4 border-right-inset" >
                    <div class="d-flex gap-1 text-primary justify-content-start align-items-start fs-4 fw-bold flex-column-reverse flex-lg-row">
                        <div class="fs-3 fw-bold" >{{ estudiantesActivosCount }} </div>
                        <!--<img src="/img/icono/grupo.svg" class="ms-1" alt="" width="35px">-->
                    </div>
                    <small class="text-start lh-1 small"><strong>Estudiantes activos</strong></small>
                </div>
                <div class="col-6 col-md-3 fs-5 py-1 px-lg-5 px-md-5 px-sm-4 border-right-inset">
                    <div class="d-flex gap-2 text-primary justify-content-start align-items-start fs-4 fw-bold flex-column-reverse flex-lg-row pt-2 pt-md-0">
                        <div class="fs-3 fw-bold">{{ aprobadosUltimoMesCount }} Cursos</div>
                        <!--<img src="/img/icono/libro.svg" alt="" width="25px" class="ms-3">-->
                    </div>
                    <small class="text-start lh-1 small"><strong>Aprobados en el último mes</strong></small>
                </div>
                <div class="col-6 col-md-3 fs-5 py-1 px-lg-5 px-md-5 px-sm-4 border-right-inset">
                    <div class="d-flex gap-2 text-primary justify-content-start align-items-start fs-4 fw-bold flex-column-reverse flex-lg-row">
                        <div class="fs-3 fw-bold">{{ insigniastotal }} Insignias</div>
                        <!--<img src="/img/icono/medalla.svg" alt="" width="30px" class="ms-3">-->
                    </div>
                    <small class="text-start lh-1 small"><strong>Obtenidas al completar rutas</strong></small>
                </div>
                <div class="col-6 col-md-3 fs-5 py-1 px-lg-5 px-md-5 px-sm-4" v-if="issuperadmin == 'true'">
                    <div class="d-flex gap-2 text-primary justify-content-start align-items-start fs-4 fw-bold flex-column-reverse flex-lg-row">
                        <div class="fs-3 fw-bold"> {{ clientesCount }} Empresas</div>
                        <!--<img src="/img/icono/edificio.svg" alt="" width="30px" class="ms-3">-->
                    </div>
                    <small class="text-start lh-1 small"><strong>Inscritas en Utel X B2B</strong></small>
                </div>
                <div class="col-6 col-md-3 fs-5 py-1 px-lg-5 px-md-5 px-sm-4"  v-if="issuperadmin != 'true'">
                    <div class="d-flex gap-2 text-primary justify-content-start align-items-start fs-4 fw-bold flex-column-reverse flex-lg-row">
                        <div class="fs-3 fw-bold">{{ tiempoLicencia }}</div>
                        <!--<img src="/img/icono/edificio.svg" alt="" width="30px" class="ms-3">-->
                    </div>
                    <small class="text-start lh-1 small"><strong>Para finalizar tu plan</strong></small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["urldatacompany", "issuperadmin"],
    data: function () {
        return {
            estudiantesActivosCount: 0,
            aprobadosUltimoMesCount: 0,
            insigniastotal: 0,
            clientesCount : 0,
            tiempoLicencia: ''
        }
    },
    mounted() {
        this.indexDashboard();
    },
    methods: {
        indexDashboard() {
            axios.get(`${this.urldatacompany}?withUsers=true`).then((dataCompany) => {
                if(dataCompany == null) return;

                this.estudiantesActivosCount = dataCompany.data[0]['usuarios'];
                this.aprobadosUltimoMesCount = dataCompany.data[1]['cursos']['count'];
                this.insigniastotal = dataCompany.data[2]['insignias'];
                if(this.issuperadmin == 'true')
                    this.clientesCount = dataCompany.data[3]['clientes'];
                else
                    this.tiempoLicencia = dataCompany.data[3]['tiempoLicencia'];                
            });
        },
    }
}
</script>

<style>

</style>